module.exports = __webpack_public_path__ + "static/img/496b3ace787342f7954b7045b8b06804.6862ad72.jpeg";